module.exports = __webpack_public_path__ + "static/media/icon_close_B.cc315ee2.svg";